<div
  class="scroll-container"
  [class.category-picker]="display === 'category-picker'"
  [class.hugescreen]="biggerThan()?.sm"
  #scrollableContainer
  (scroll)="checkScrolls(scrollableContainer)"
  (change)="checkScrolls(scrollableContainer)">
  <ng-content></ng-content>
</div>

@if (showArrowLeft() === true) {
  <div class="scroll-arrow left" (click)="scrollLeft(scrollableContainer)">
    <popsy-icon-arrow-left-1 class="icon gray-light bold" />
  </div>
}

@if (showArrowRight() === true) {
  <div class="scroll-arrow right" (click)="scrollRight(scrollableContainer)">
    <popsy-icon-arrow-right-1 class="icon gray-light bold" />
  </div>
}
